import { API_URL } from "env";

import { mixLogOut } from '../services/mixin';

export interface NotificationReadLogItem {
    id: number;
    user_id: number;
    notification_id: number;
    customer_id: number;
    created_at: string;
    updated_at: string;
    user?: {
        id: number;
        fullname?: string;
        email?: string;
    } | null;
    notification?: {
        id: number;
        type?: string;
        title?: string;
        content?: string;
        related_id?: number;
        related_type?: string;
        // Người tạo thông báo (khác với user - người đọc thông báo)
        creator?: {
            id: number;
            fullname?: string;
            email?: string;
        } | null;
    } | null;
    customer?: {
        id: number;
        display_name?: string;
        phone?: string;
        avatar?: string;
        [key: string]: any;
    } | null;
}

export interface NotificationReadLogListResponse {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: NotificationReadLogItem[];
    } | null;
}

// Danh sách log đọc thông báo (chỉ ghi nhận với loại thông báo cuộc gọi thất bại - call_failed).
// GET /api/v1/be/notification-read-logs — hỗ trợ lọc theo user_id, customer_id, notification_id + phân trang.
export async function getNotificationReadLogs(params?: {
    user_id?: number;
    customer_id?: number;
    notification_id?: number;
    page?: number;
    limit?: number;
}): Promise<NotificationReadLogListResponse> {
    try {
        const token = localStorage.getItem('token') || '';
        const query = new URLSearchParams();
        if (params?.user_id) query.append('user_id', String(params.user_id));
        if (params?.customer_id) query.append('customer_id', String(params.customer_id));
        if (params?.notification_id) query.append('notification_id', String(params.notification_id));
        if (params?.page) query.append('page', String(params.page));
        if (params?.limit) query.append('limit', String(params.limit));
        const queryString = query.toString();

        const response = await fetch(`${API_URL}/api/v1/be/notification-read-logs${queryString ? `?${queryString}` : ''}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            if (response.status === 401) { mixLogOut(); }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json() as NotificationReadLogListResponse;
    } catch (error) {
        console.error('Failed to fetch notification read logs:', error);
        return {
            status: false,
            data: null,
        };
    }
}
